import { render, staticRenderFns } from "./CardAlbum.vue?vue&type=template&id=22467700&scoped=true&class=flex&"
import script from "./CardAlbum.vue?vue&type=script&lang=js&"
export * from "./CardAlbum.vue?vue&type=script&lang=js&"
import style0 from "./CardAlbum.vue?vue&type=style&index=0&id=22467700&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22467700",
  null
  
)

export default component.exports